import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen py-20"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center mb-16"
        >
          <h1 className="font-poppins text-5xl font-bold text-primary mb-6">
            About Raheem
          </h1>
          <div className="w-24 h-1 bg-accent-primary mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="lg:col-span-1"
          >
            <div className="w-full h-[600px] bg-gray-100 rounded-lg overflow-hidden">
              <iframe
                src="https://content.raheem.work/file/RB/Logos-and-Favicons/RB-Professional-Photo.html?player=DASZeph"
                className="w-full h-full border-0"
                title="Raheem Bishop Professional Portrait"
                style={{ 
                  objectFit: 'cover',
                  overflow: 'hidden'
                }}
              />
            </div>
          </motion.div>

          {/* Biography */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="lg:col-span-2 space-y-6"
          >
            <div className="prose prose-lg max-w-none">
              <p className="font-barlow text-lg text-primary leading-relaxed">
                As a child in Barbados, Raheem was fascinated by sketching buildings and plans. 
                As he grew up, he continued exploring how things were constructed and why they 
                functioned the way they did. He went on to receive a Bachelor's degree in 
                Architecture at The University of Technology, Jamaica, where he was also named 
                valedictorian in his graduating year.
              </p>

              <p className="font-barlow text-lg text-primary leading-relaxed">
                Furthering his education, he graduated from Florida International University 
                in Miami, FL, with his Master's in Architecture, ultimately gaining full 
                licensure a few years after graduation.
              </p>

              <p className="font-barlow text-lg text-primary leading-relaxed">
                As he continues to grow and evolve in his profession, Raheem remains rooted 
                in his beginnings on the beautiful shores of Barbados. He credits his passion 
                and success to his Caribbean roots, which have instilled in him a strong work 
                ethic, dedication, and cultural appreciation.
              </p>

              <p className="font-barlow text-lg text-primary leading-relaxed">
                With almost a decade of experience in the field, Raheem continues to evolve 
                as an architect, constantly expanding his knowledge and skills. His diverse 
                portfolio showcases his versatility and creativity, ranging from aviation to 
                museums, and recreation-based commercial and retail projects.
              </p>
            </div>

            {/* Education & Credentials */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="mt-12 p-6 bg-gray-50 rounded-lg"
            >
              <h3 className="font-poppins text-xl font-semibold text-primary mb-4">
                Education & Credentials
              </h3>
              <div className="space-y-3">
                <div>
                  <h4 className="font-barlow font-semibold text-primary">
                    Master of Architecture
                  </h4>
                  <p className="font-barlow text-tertiary">
                    Florida International University, Miami, FL
                  </p>
                </div>
                <div>
                  <h4 className="font-barlow font-semibold text-primary">
                    Bachelor of Architecture (Valedictorian)
                  </h4>
                  <p className="font-barlow text-tertiary">
                    University of Technology, Jamaica
                  </p>
                </div>
                <div>
                  <h4 className="font-barlow font-semibold text-primary">
                    Licensed Architect
                  </h4>
                  <p className="font-barlow text-tertiary">
                    State of Florida
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default About;